module.exports = __webpack_public_path__ + "tg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tg.svg
// module id = 836
// module chunks = 0